var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-reconciliation-more"},[_c('PageReconciliationApproved',{attrs:{"kitId":_vm.kitId,"pageType":"more"}}),_c('RealtimeSystemMap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }